import { DocumentService } from 'gw-capability-policydocument';
import { SgUsabilityUtils } from 'saga-modules';

const downloadDocument = (event, policyNumber, type) => {
    if (event) {
        event.preventDefault();
    }
    DocumentService.retrieveCustomerDocumentPdf(policyNumber, type).then((file) => {
        if (SgUsabilityUtils.isIOS() || SgUsabilityUtils.isMac()) { // opening window in async call is being blocked by Safari
            window.location = file;
        } else {
            window.open(`${file}`);
        }
    }).catch((err) => {
        const error = { error: err, customErrorMessage: 'Could not retrieve pdf document' };
        throw error;
    });
};

export default {
    downloadDocument
};
